var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxlogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.9 33.7",
    style: {
      enableBackground: "new 0 0 17.9 33.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.1,18.9C1,18.9,0,18,0,16.8s0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S3.2,18.9,2.1,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,16.8c0,2.8-0.9,5.3-2.3,7.4c-0.9,1.3-2,2.4-3.3,3.3c-2.1,1.4-4.6,2.2-7.3,2.2c-1.7,0-3.4-0.3-4.9-1v-5.3 c1.4,1,3.1,1.6,4.9,1.6c1.4,0,2.7-0.4,3.9-1l-0.5-0.6l3.3-3.3l0.6,0.6c0.7-1.2,1.1-2.6,1.1-4.1c0-4.6-3.7-8.3-8.3-8.3 c-1.8,0-3.5,0.6-4.9,1.6V4.8c1.5-0.6,3.1-1,4.9-1C12,3.9,17.8,9.7,17.8,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,16.8c0,1.1-0.9,2.1-2.1,2.1C1,18.9,0,18,0,16.8s0.9-2.1,2.1-2.1C3.2,14.8,4.2,15.7,4.2,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,20.9c-0.8,1.4-1.9,2.5-3.3,3.3l-0.5-0.6l3.3-3.3L12.1,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,16.8c0,1.1-0.9,2.1-2.1,2.1C1,18.9,0,18,0,16.8s0.9-2.1,2.1-2.1C3.2,14.8,4.2,15.7,4.2,16.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.2,26 13.9,29.3 12.2,27.6 8.8,24.2 8.2,23.6 11.5,20.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxlogo);
export default __webpack_public_path__ + "static/media/boxlogo.338e65de416715c5412e6b0dafbd1ec1.svg";
export { ForwardRef as ReactComponent };